<template>
  <div class="container">
    <div class="grid-wrapper">
      <div class="grid-item">
        <div class="card">
          <img src="../assets/1.webp" alt="Image of end product" />
        </div>
      </div>
      <div class="grid-item">
        <div class="card">
          <img src="../assets/2.webp" alt="Image of end product" />
        </div>
      </div>
      <div class="grid-item">
        <div class="card">
          <img src="../assets/5.webp" alt="Image of end product" />
        </div>
      </div>
      <div class="grid-item">
        <div class="card">
          <img src="../assets/6.webp" alt="Image of end product" />
        </div>
      </div>
      <div class="grid-item">
        <div class="card">
          <img src="../assets/7.webp" alt="Image of end product" />
        </div>
      </div>
      <div class="grid-item">
        <div class="card">
          <img src="../assets/8.webp" alt="Image of end product" />
        </div>
      </div>
    </div>
    <router-link to="/gallery" class="CTA">View More</router-link>
  </div>
</template>

<script>
export default {
  setup() {
    return {};
  },
};
</script>

<style scoped>
.container {
  margin: 2rem auto;
  max-width: 1000px;
}
.grid-wrapper {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
  margin: 2rem auto;
  padding: 0 1rem;
}
.grid-item {
  width: 100%;
  height: 100%;
  box-shadow: 7px 10px 12px 2px rgba(0, 0, 0, 0.65);
  border-radius: 30px;
  overflow: hidden;
}
.grid-item .card {
  width: 100%;
  height: 100%;
}

.grid-item:nth-child(1) {
  border-radius: 10px;
  padding: 0.5em;
  background-color: #fff;
}

.grid-item:nth-child(1) .card img {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  object-fit: cover;
  object-position: center;
}
.grid-item .card img {
  width: 100%;
  height: 100%;
  border-radius: 30px;
  object-fit: cover;
  object-position: center;
}

.CTA {
  display: inline-block;
  font-family: boombox, Helvetica, Arial, sans-serif;
  margin-top: 1rem;
  max-width: 300px;
  min-width: 150px;

  color: #fff;
  padding: 12px 25px;
  border-radius: 22px;
  font-size: 0.85rem;
  text-transform: uppercase;
  box-shadow: rgba(0, 0, 0, 0.17) 0px -23px 25px 0px inset,
    rgba(0, 0, 0, 0.15) 0px -36px 30px 0px inset,
    rgba(0, 0, 0, 0.1) 0px -79px 40px 0px inset, rgba(0, 0, 0, 0.06) 0px 2px 1px,
    rgba(0, 0, 0, 0.09) 0px 4px 2px, rgba(0, 0, 0, 0.09) 0px 8px 4px,
    rgba(0, 0, 0, 0.09) 0px 16px 8px, rgba(0, 0, 0, 0.09) 0px 32px 16px;
  background-color: #fa4349;

  transition: all 0.25s ease-in-out;
}

.CTA:hover {
  transform: scale(1.05);
}

/* ************************Media************************ */

@media screen and (min-width: 500px) {
  .grid-wrapper {
    padding: 3rem;
    gap: 20px;
    grid-template-columns: repeat(2, 1fr);
  }
  .grid-item {
    background-color: #ccc4c4;
    grid-column: span 1;
  }
}
@media screen and (min-width: 768px) {
  .container {
    margin: 5rem auto;
  }
  .grid-wrapper {
    gap: 30px;
    grid-template-columns: repeat(3, 1fr);
  }

  .grid-item {
    grid-column: span 1;
  }
}
@media screen and (min-width: 500px) {
  .CTA {
    font-size: 1rem;
  }
}
</style>